import React, { useEffect, useState } from "react";
import { getDiscountCoupons, createDiscountCoupon, updateDiscountCoupon, deleteDiscountCoupon } from "../../Services/DiscountCoupons";
import { appTypeBadges, getAppInfoFromProductId } from "../../Services/Constant/Constant";
import Loader from "../../Layouts/Loader";

const DiscountCoupons = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ code: "", enabled: true, expiry: "", product_id: "event_prepayment_discounted" });
  const [error, setError] = useState(null);

  const reload = () => {
    setLoading(true);
    getDiscountCoupons()
      .then(res => setRows(res.data.data.responseData))
      .catch(() => setError("Failed to load coupons"))
      .finally(() => setLoading(false));
  };

  useEffect(() => { reload(); }, []);

  const onCreate = () => {
    setCreating(true);
    createDiscountCoupon({ ...form, expiry: form.expiry || null })
      .then(() => { setForm({ code: "", enabled: true, expiry: "", product_id: "event_prepayment_discounted" }); reload(); })
      .catch(() => setError("Failed to create coupon"))
      .finally(() => setCreating(false));
  };

  const onUpdate = (payload) =>
    updateDiscountCoupon(payload).then(reload).catch(() => setError("Failed to update coupon"));

  const onDelete = (code) =>
    deleteDiscountCoupon(code).then(reload).catch(() => setError("Failed to delete coupon"));

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="page_header"><h2 className="mb-0">Discount Coupons</h2></div>
        <div className="d-flex gap-2">
          {appTypeBadges.map((badge) => (
            <span
              key={badge.value}
              className="badge"
              style={{ backgroundColor: badge.color, color: 'white', fontSize: '0.9rem', padding: '0.5rem 0.75rem' }}
            >
              {badge.icon} {badge.name}
            </span>
          ))}
        </div>
      </div>

      {error && <div className="alert alert-danger" role="alert">{error}</div>}

      <div className="card mb-3">
        <div className="card-body">
          <div className="row g-2">
            <div className="col-md-3">
              <input className="form-control" placeholder="CODE" value={form.code} onChange={(e)=>setForm(f=>({...f, code: e.target.value.toUpperCase()}))}/>
            </div>
            <div className="col-md-3">
              <input type="date" className="form-control" value={form.expiry} onChange={(e)=>setForm(f=>({...f, expiry: e.target.value}))}/>
            </div>
            <div className="col-md-3">
              <select className="form-select" value={form.product_id} onChange={(e)=>setForm(f=>({...f, product_id: e.target.value}))}>
                <optgroup label="Wedding Bets">
                  <option value="event_prepayment_mini">event_prepayment_mini</option>
                  <option value="event_prepayment_mini_discounted">event_prepayment_mini_discounted</option>
                  <option value="event_prepayment_discounted">event_prepayment_discounted</option>
                </optgroup>
                <optgroup label="Guess The Baby">
                  <option value="dig_baby_pool_gtb">dig_baby_pool_gtb</option>
                  <option value="dig_baby_pool_gtb_discount">dig_baby_pool_gtb_discount</option>
                  <option value="event_prepayment_discounted_gtb">event_prepayment_discounted_gtb</option>
                  <option value="event_prepayment_mini_gtb">event_prepayment_mini_gtb</option>
                  <option value="event_prepayment_mini_discounted_gtb">event_prepayment_mini_discounted_gtb</option>
                </optgroup>
              </select>
            </div>
            <div className="col-md-2 form-check d-flex align-items-center">
              <input className="form-check-input me-2" type="checkbox" checked={form.enabled} onChange={(e)=>setForm(f=>({...f, enabled: e.target.checked}))}/>
              <label className="form-check-label">Enabled</label>
            </div>
            <div className="col-md-1">
              <button className="btn btn-primary w-100" onClick={onCreate} disabled={creating || !form.code}>Add</button>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          {loading ? <Loader /> : (
            <div className="table-responsive">
              <table className="table table-striped table-hover mb-0">
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>App</th>
                    <th>Enabled</th>
                    <th>Expiry</th>
                    <th>Product ID</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map(row => (
                    <EditableRow key={row.code} row={row} onUpdate={onUpdate} onDelete={onDelete} />
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const EditableRow = ({ row, onUpdate, onDelete }) => {
  const [editing, setEditing] = useState(false);
  const [state, setState] = useState({ enabled: row.enabled, expiry: row.expiry ? row.expiry.slice(0,10) : "", product_id: row.product_id });
  const appInfo = getAppInfoFromProductId(row.product_id);

  const save = () => onUpdate({ code: row.code, ...state }).then(()=>setEditing(false));

  return (
    <tr>
      <td>{row.code}</td>
      <td>
        <span className="badge" style={{ backgroundColor: appInfo.color, color: 'white', fontSize: '0.85rem' }}>
          {appInfo.icon} {appInfo.name}
        </span>
      </td>
      <td>{editing ? (<input type="checkbox" checked={state.enabled} onChange={(e)=>setState(s=>({...s, enabled: e.target.checked}))}/>) : (row.enabled ? 'true' : 'false')}</td>
      <td>{editing ? (<input type="date" className="form-control" value={state.expiry} onChange={(e)=>setState(s=>({...s, expiry: e.target.value}))}/>) : (row.expiry ? row.expiry.slice(0,10) : '')}</td>
      <td>{editing ? (
        <select className="form-select" value={state.product_id} onChange={(e)=>setState(s=>({...s, product_id: e.target.value}))}>
          <optgroup label="Wedding Bets">
          <option value="event_prepayment_discounted">event_prepayment_discounted</option>
            <option value="event_prepayment_mini">event_prepayment_mini</option>
            <option value="event_prepayment_mini_discounted">event_prepayment_mini_discounted</option>
          </optgroup>
          <optgroup label="Guess The Baby">
            <option value="dig_baby_pool_gtb">dig_baby_pool_gtb</option>
            <option value="dig_baby_pool_gtb_discount">dig_baby_pool_gtb_discount</option>
            <option value="event_prepayment_discounted_gtb">event_prepayment_discounted_gtb</option>
            <option value="event_prepayment_mini_gtb">event_prepayment_mini_gtb</option>
            <option value="event_prepayment_mini_discounted_gtb">event_prepayment_mini_discounted_gtb</option>
          </optgroup>
        </select>
      ) : row.product_id}</td>
      <td>
        {editing ? (
          <>
            <button className="btn btn-success btn-sm me-2" onClick={save}>Save</button>
            <button className="btn btn-secondary btn-sm" onClick={()=>setEditing(false)}>Cancel</button>
          </>
        ) : (
          <>
            <button className="btn btn-outline-primary btn-sm me-2" onClick={()=>setEditing(true)}>Edit</button>
            <button className="btn btn-outline-danger btn-sm" onClick={()=>onDelete(row.code)}>Delete</button>
          </>
        )}
      </td>
    </tr>
  );
};

export default DiscountCoupons;


